var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-info"},[_c('button',{staticClass:"delete",on:{"click":_vm.closeMessage}}),_c('p',[_vm._v(_vm._s(_vm.$store.state.notificationText))])])}
var staticRenderFns = []

export { render, staticRenderFns }